module.exports = __webpack_public_path__ + "img/google-presentations.3c2f600b.png";